import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalSize = ['sm', 'md', 'lg'];

const CordataModal = ({
  children,
  isOpen,
  headerIcon,
  size,
  title,
  subTitle,
  action,
  onClose,
  showCloseButton,
}) => (
  <Modal isOpen={isOpen} onClosed={onClose} backdrop="static" size={size}>
    <ModalHeader
      className="justify-content-center"
      toggle={showCloseButton ? onClose : undefined}
    >
      <div className="d-flex flex-column align-items-center">
        {headerIcon && (
          <FontAwesomeIcon icon={headerIcon} size="4x" className="" />
        )}
        <div>
          {title && <h3>{title}</h3>}
          {subTitle && <p>{subTitle}</p>}
        </div>
      </div>
    </ModalHeader>
    {children && (
      <ModalBody style={{ overflowY: 'auto', maxHeight: '70vh' }}>
        {children}
      </ModalBody>
    )}
    {action && <ModalFooter>{action}</ModalFooter>}
  </Modal>
);

CordataModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  headerIcon: PropTypes.node,
  size: PropTypes.oneOf(ModalSize),
  title: PropTypes.string,
  subTitle: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
};

CordataModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  showCloseButton: false,
  headerIcon: undefined,
  size: 'md',
  title: undefined,
  subTitle: undefined,
  action: undefined,
  children: undefined,
};

export default CordataModal;
